import { c as _c } from "react/compiler-runtime";
import styles from '@/app/cv/components/sections/products/index.module.css';
import { ProductBadge } from '@/app/cv/components/sections/products/shared/badge';
import type { ProductBaseProps } from '@/app/cv/components/sections/products/types';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
type SlideContentProps = Pick<ProductBaseProps, 'title' | 'description' | 'badge'> & {
  isDark?: boolean;
};
export const SlideContent = t0 => {
  const $ = _c(27);
  const {
    title,
    description,
    badge,
    isDark: t1
  } = t0;
  const isDark = t1 === undefined ? false : t1;
  if (badge?.label) {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = createDataAttributes({
        test: "content-with-badge"
      });
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    let t3;
    if ($[1] !== badge) {
      t3 = <ProductBadge {...badge} />;
      $[1] = badge;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    let t4;
    if ($[3] !== isDark || $[4] !== title) {
      t4 = !!title && <h3 className={cn("text-sub-h3 font-noto-bold", {
        "text-white": isDark
      })} dangerouslySetInnerHTML={{
        __html: title || ""
      }} {...createDataAttributes({
        test: "title"
      })} />;
      $[3] = isDark;
      $[4] = title;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] !== description || $[7] !== isDark) {
      t5 = !!description && <div className={cn("text-body-2 text-html-content", styles.contentDescription, {
        "text-white": isDark,
        "text-gray-700": !isDark
      })} dangerouslySetInnerHTML={{
        __html: description
      }} {...createDataAttributes({
        test: "description"
      })} />;
      $[6] = description;
      $[7] = isDark;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    let t6;
    if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
      t6 = <div className="where-span:text-inline-wrap flex flex-col gap-3" {...t2}>{t3}{t4}{t5}</div>;
      $[9] = t2;
      $[10] = t3;
      $[11] = t4;
      $[12] = t5;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    return t6;
  }
  let t2;
  if ($[14] !== isDark) {
    t2 = cn("text-sub-h2 font-noto-bold", {
      "text-white": isDark
    });
    $[14] = isDark;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  const t3 = title || "";
  let t4;
  if ($[16] !== t3) {
    t4 = {
      __html: t3
    };
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== t2 || $[19] !== t4) {
    t5 = <h3 className={t2} dangerouslySetInnerHTML={t4} />;
    $[18] = t2;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== description || $[22] !== isDark) {
    t6 = !!description && <div className={cn("text-body-1 [&_small]:text-caption mt-2 [&_small]:block", {
      "text-white": isDark
    })} dangerouslySetInnerHTML={{
      __html: description
    }} />;
    $[21] = description;
    $[22] = isDark;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== t5 || $[25] !== t6) {
    t7 = <div>{t5}{t6}</div>;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  return t7;
};